import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      data-testid="offline-banner"
      className="sticky top-0 z-50 flex items-center justify-center gap-2 bg-amber-500 text-zinc-950 text-xs font-semibold px-4 py-2"
    >
      <WifiOff className="h-3.5 w-3.5" />
      You&apos;re offline — showing your last saved data
    </div>
  );
}
